export default __webpack_public_path__ + "static/media/hero-level-1-bg.0bcc5672.webp";